import React, { useState } from 'react';
import { sipCodeExample } from '../../data/codeExamples';
import './IntegrationSection.css';

const IntegrationSection: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'nodejs' | 'python' | 'curl'>('nodejs');

  return (
    <section id="integration" className="integration-section">
      <div className="integration-container">
        <div className="integration-header">
          <h2 className="integration-title">Integrate in minutes.</h2>
          <p className="integration-description">
            Get started with our telephony platform in under 5 minutes. Simple API integration, 
            comprehensive documentation, and dedicated support to help you succeed.
          </p>
        </div>
        
        <div className="integration-content">
          <div className="integration-visual">
            <div className="sip-modal">
              <div className="modal-header">
                <h3 className="modal-title">Provision SIP Trunk</h3>
                <div className="modal-close">×</div>
              </div>
              
              <div className="modal-body">
                <div className="form-group">
                  <label className="form-label">Trunk Name</label>
                  <input 
                    type="text" 
                    className="form-input" 
                    placeholder="Enter trunk name"
                    readOnly
                  />
                </div>
                
                <div className="form-group">
                  <label className="form-label">SIP URI</label>
                  <input 
                    type="text" 
                    className="form-input" 
                    placeholder="sip:trunk@yourdomain.com"
                    readOnly
                  />
                </div>
                
                <div className="form-group">
                  <label className="form-label">Capacity</label>
                  <select className="form-select" disabled>
                    <option>100 concurrent calls</option>
                    <option>500 concurrent calls</option>
                    <option>1000 concurrent calls</option>
                  </select>
                </div>
                
                <div className="form-actions">
                  <button className="btn-secondary">Cancel</button>
                  <button className="btn-primary">Provision Trunk</button>
                </div>
              </div>
            </div>
            
            <div className="code-editor">
              <div className="editor-header">
                <div className="editor-tabs">
                  <div 
                    className={`tab ${activeTab === 'nodejs' ? 'active' : ''}`}
                    onClick={() => setActiveTab('nodejs')}
                  >
                    Node.js
                  </div>
                  <div 
                    className={`tab ${activeTab === 'python' ? 'active' : ''}`}
                    onClick={() => setActiveTab('python')}
                  >
                    Python
                  </div>
                  <div 
                    className={`tab ${activeTab === 'curl' ? 'active' : ''}`}
                    onClick={() => setActiveTab('curl')}
                  >
                    cURL
                  </div>
                </div>
              </div>
              
              <div className="editor-content">
                {sipCodeExample[activeTab].map((line, index) => (
                  <div key={index} className="code-line">
                    <span className="line-number">{index + 1}</span>
                    <span className="code-text">{line}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          <div className="integration-info">
            <div className="info-section">
              <h3 className="info-title">Simple API Integration</h3>
              <p className="info-description">
                Our RESTful API is designed for developers. Clear documentation, 
                comprehensive examples, and SDKs for popular programming languages.
              </p>
            </div>
            
            <div className="info-section">
              <h3 className="info-title">Quick Setup</h3>
              <p className="info-description">
                Get your first SIP trunk provisioned in under 5 minutes. 
                No complex configurations or lengthy approval processes.
              </p>
            </div>
            
            <div className="info-section">
              <h3 className="info-title">Dedicated Support</h3>
              <p className="info-description">
                Our engineering team is here to help you succeed. 
                Get answers to your questions and guidance on best practices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntegrationSection;
